import http from '../../../service/axios';

/**
 * Какой номер бэк подтверждает прямо сейчас: 'old' — текущий, 'new' — новый.
 * Приходит в каждом ответе, по нему восстанавливаем шаг, если заявка на смену
 * уже висит активной (например, пользователь закрыл шторку на полпути).
 */
export type PhoneChangeStage = 'old' | 'new';

export interface IPhoneChangeResponse {
  success: boolean;
  message?: string;
  stage?: PhoneChangeStage;
}

// Эндпоинты ждут номер одной строкой с кодом страны и без плюса —
// "998901234567", в отличие от user/code, который принимает "+998…".
// PhoneField хранит только 9 цифр, поэтому код приклеиваем здесь.
const withCountryCode = (phone: string) =>
  `998${phone.replace(/\D/g, '').slice(-9)}`;

export const phoneAPI = {
  /**
   * Заводит заявку на смену номера: phone — это НОВЫЙ номер, а код уходит на
   * текущий. Повторный вызов при активной заявке просто переотправляет код
   * текущего шага.
   */
  sendCode: async (phone: string) =>
    await http.post<IPhoneChangeResponse>('phone/send-code', {
      phone: withCountryCode(phone),
    }),
  /**
   * Один эндпоинт на оба подтверждения: какой номер сверять, бэк знает по
   * активной заявке, поэтому в теле только код. После подтверждения текущего
   * номера код на новый уходит сам.
   */
  verifyCode: async (code: string) =>
    await http.post<IPhoneChangeResponse>('phone/verify-code', { code }),
};
